<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">With gratitude to Carolyn McSparren, Phyllis Appleby, Kenlyn Spence, and Barbara Christopher for all their support, advice—sometimes painful but always on target—and, most of all, their friendship. I love you all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?608337be